import script from "./PUR02_016RPT.vue?vue&type=script&setup=true&lang=js"
export * from "./PUR02_016RPT.vue?vue&type=script&setup=true&lang=js"

import "./PUR02_016RPT.vue?vue&type=style&index=0&id=67632493&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67632493"]])

export default __exports__